export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
export const RECEIVE_PAGE_HOME = "RECEIVE_PAGE_HOME";
export const RECEIVE_POST = "RECEIVE_POST";
export const RECEIVE_PAGE_CAREER = "RECEIVE_PAGE_CAREER";
export const RECEIVE_POSTCATEGORIES = "RECEIVE_POSTCATEGORIES";
export const RECEIVE_PROMOTION = "RECEIVE_PROMOTION";
export const RECEIVE_PROMOTIONCATEGORIES = "RECEIVE_PROMOTIONCATEGORIES";
export const RECEIVE_EVENT = "RECEIVE_EVENT";
export const RECEIVE_CAREER_POSITIONS = "RECEIVE_CAREER_POSITIONS";
export const RECEIVE_CONTACT_PAGE = "RECEIVE_CONTACT_PAGE";
export const RECEIVE_PROMOTION_PAGE = "RECEIVE_PROMOTION_PAGE";
export const RECEIVE_EVENT_PAGE = "RECEIVE_EVENT_PAGE";
export const RECEIVE_NEWS_PAGE = "RECEIVE_NEWS_PAGE";
export const RECEIVE_SHOWTIMES = "RECEIVE_SHOWTIMES";
export const RECEIVE_OURSHOW_PAGE = "RECEIVE_OURSHOW_PAGE";
export const RECEIVE_HIGHLIGHTSHOW_PAGE = "RECEIVE_HIGHLIGHTSHOW_PAGE";
export const RECEIVE_AUTH = "RECEIVE_AUTH";
export const IS_LOGIN = "IS_LOGIN";
export const IS_LOGIN_CHECKED = "IS_LOGIN_CHECKED";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";



// WEBPACK FOOTER //
// ./src/actions/actionType.js